// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-policy {
  padding: 12px 14px;
  overflow: auto;
  font-size: 13px;
}

.tp-loading, .tp-muted {
  opacity: 0.65;
}

.tp-error {
  color: #d66;
  margin: 6px 0;
}

.tp-notice {
  color: #3a7;
  margin: 6px 0;
}

.tp-tabs {
  display: flex;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.3);
  margin-bottom: 12px;
  padding-bottom: 6px;
}
.tp-tabs button {
  background: transparent;
  border: 1px solid transparent;
  color: inherit;
  padding: 5px 12px;
  border-radius: 6px;
  cursor: pointer;
}
.tp-tabs button.active {
  border-color: rgba(128, 128, 128, 0.5);
  background: rgba(128, 128, 128, 0.12);
  font-weight: 600;
}
.tp-tabs .tp-state {
  opacity: 0.6;
  font-size: 12px;
  margin-right: 8px;
}

.tp-spacer {
  flex: 1;
}

.tp-primary {
  background: #61afef !important;
  color: #fff !important;
  border-color: transparent !important;
}

.tp-primary[disabled] {
  opacity: 0.5;
}

.tp-secondary {
  background: transparent;
  border: 1px solid rgba(128, 128, 128, 0.5);
  color: inherit;
  padding: 4px 10px;
  border-radius: 6px;
  cursor: pointer;
  margin: 6px 0 12px;
}

.tp-link {
  background: none;
  border: none;
  color: inherit;
  opacity: 0.6;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  font: inherit;
}

.tp-small {
  font-size: 12px;
}

h3 {
  margin: 6px 0 10px;
}

h4 {
  margin: 18px 0 6px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  opacity: 0.75;
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}

.tp-h4-note {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 400;
  opacity: 0.8;
}

.tp-kv {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 4px 14px;
}

.tp-kv div:nth-child(odd) {
  opacity: 0.65;
}

.tp-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
}

.tp-check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.tp-block {
  display: flex;
  margin: 8px 0;
}

.tp-sub {
  font-size: 11px;
  opacity: 0.65;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-right: 8px;
}

.tp-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 6px 0;
  flex-wrap: wrap;
}

.tp-wide {
  flex: 1;
  min-width: 240px;
}

.tp-table {
  width: 100%;
  border-collapse: collapse;
  margin: 4px 0;
}
.tp-table th, .tp-table td {
  text-align: left;
  padding: 4px 6px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.25);
}
.tp-table th {
  font-size: 11px;
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

input[type=text]:not([matInput]), input:not([type]):not([matInput]), select:not([matNativeControl]) {
  background: transparent;
  color: inherit;
  border: 1px solid rgba(128, 128, 128, 0.45);
  border-radius: 5px;
  padding: 3px 6px;
  font: inherit;
}

code {
  font-size: 12px;
  opacity: 0.85;
}

.tp-sentence {
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(220px, 2fr);
  gap: 16px;
  padding: 12px 14px;
  border-radius: 8px;
  background: rgba(97, 175, 239, 0.1);
  margin-bottom: 6px;
}

.tp-sentence-text {
  font-size: 15px;
  line-height: 1.55;
}
.tp-sentence-text b {
  cursor: pointer;
  border-bottom: 1px dotted rgba(97, 175, 239, 0.9);
  font-weight: 600;
}
.tp-sentence-text b:hover {
  background: rgba(97, 175, 239, 0.18);
}

.tp-viewas {
  border-left: 1px solid rgba(128, 128, 128, 0.3);
  padding-left: 14px;
  font-size: 12px;
}
.tp-viewas label {
  opacity: 0.75;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 11px;
  display: flex;
  gap: 8px;
  align-items: center;
}
.tp-viewas select {
  text-transform: none;
  letter-spacing: 0;
  font-size: 12px;
}

.tp-preview {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tp-preview-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.tp-preview-vendor {
  opacity: 0.65;
  min-width: 58px;
}

@media (max-width: 720px) {
  .tp-sentence {
    grid-template-columns: 1fr;
  }
  .tp-viewas {
    border-left: none;
    padding-left: 0;
  }
}
.tp-chips {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 5px;
  align-items: center;
}

.tp-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 9px;
  border-radius: 999px;
  border: 1px solid rgba(128, 128, 128, 0.45);
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  opacity: 0.75;
  line-height: 1.5;
}
.tp-chip small {
  opacity: 0.7;
}
.tp-chip:hover {
  opacity: 1;
}
.tp-chip.on {
  opacity: 1;
  border-color: #61afef;
  background: rgba(97, 175, 239, 0.18);
  font-weight: 600;
}
.tp-chip.tp-chip-deny.on {
  border-color: #e06c75;
  background: rgba(224, 108, 117, 0.18);
  text-decoration: line-through;
}
.tp-chip.tp-chip-static {
  cursor: default;
  opacity: 1;
  border-color: rgba(97, 175, 239, 0.5);
}

.tp-provider {
  border: 1px solid rgba(128, 128, 128, 0.25);
  border-radius: 8px;
  padding: 6px 10px;
  margin: 4px 0;
}
.tp-provider.off {
  opacity: 0.55;
}

.tp-provider-head {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  min-height: 26px;
}

.tp-provider-body {
  padding: 6px 0 2px 26px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.tp-switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  cursor: pointer;
  min-width: 190px;
}

.tp-via {
  display: inline-flex;
  gap: 10px;
  align-items: center;
  font-size: 12px;
  opacity: 0.8;
}

.tp-seg {
  display: inline-flex;
  border: 1px solid rgba(128, 128, 128, 0.45);
  border-radius: 6px;
  overflow: hidden;
}
.tp-seg button {
  background: transparent;
  border: none;
  color: inherit;
  font: inherit;
  font-size: 12px;
  padding: 2px 10px;
  cursor: pointer;
  opacity: 0.7;
}
.tp-seg button.active {
  background: rgba(128, 128, 128, 0.18);
  opacity: 1;
  font-weight: 600;
}

.tp-versions {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 14px;
  padding: 4px 8px;
  border-left: 2px solid rgba(128, 128, 128, 0.3);
}

.tp-group {
  border: 1px solid rgba(128, 128, 128, 0.3);
  border-radius: 8px;
  padding: 8px 10px;
  margin: 8px 0;
}

.tp-group-head {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
}

.tp-group-name {
  width: 200px;
}

.tp-group-members {
  flex: 1;
}

.tp-group-line {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 4px 0;
}
.tp-group-line .tp-sub {
  min-width: 56px;
  padding-top: 4px;
}
.tp-group-line .tp-allow {
  color: #61afef;
  opacity: 0.9;
}
.tp-group-line .tp-deny {
  color: #e06c75;
  opacity: 0.9;
}

.tp-group-more {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed rgba(128, 128, 128, 0.3);
}

.tp-agent {
  border: 1px solid rgba(128, 128, 128, 0.3);
  border-radius: 8px;
  padding: 8px 10px;
  margin: 8px 0;
}
.tp-agent.unhealthy {
  border-color: rgba(224, 108, 117, 0.55);
}

.tp-agent-head {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.tp-agent-name {
  font-weight: 600;
}

.tp-health-ok {
  color: #3a7;
  font-size: 12px;
}

.tp-issue {
  color: #e06c75;
  font-size: 12px;
  margin: 3px 0 0 2px;
}

.tp-chip-bad {
  border-color: rgba(224, 108, 117, 0.6);
  color: #e06c75;
}

.tp-agent-edit {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed rgba(128, 128, 128, 0.3);
}

.tp-temp {
  width: 64px;
}

.tp-prompt {
  width: 100%;
  background: transparent;
  color: inherit;
  border: 1px solid rgba(128, 128, 128, 0.45);
  border-radius: 5px;
  padding: 6px 8px;
  font: inherit;
  font-size: 12px;
}

.tp-agent-grid tbody tr {
  cursor: pointer;
}
.tp-agent-grid tbody tr:hover {
  background: rgba(128, 128, 128, 0.08);
}
.tp-agent-grid tbody tr.selected {
  background: rgba(97, 175, 239, 0.12);
}
.tp-agent-grid tbody tr.row-unhealthy td:first-child {
  border-left: 2px solid rgba(224, 108, 117, 0.7);
}

.tp-issue-count {
  color: #e06c75;
  font-size: 12px;
}

.tp-toggle {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  font-size: 12px;
}
.tp-toggle input {
  display: none;
}
.tp-toggle .tp-track {
  width: 30px;
  height: 16px;
  border-radius: 999px;
  background: rgba(128, 128, 128, 0.45);
  position: relative;
  transition: background 0.15s;
}
.tp-toggle .tp-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  transition: left 0.15s;
}
.tp-toggle input:checked + .tp-track {
  background: #61afef;
}
.tp-toggle input:checked + .tp-track .tp-thumb {
  left: 16px;
}

.tp-src {
  opacity: 0.55;
  font-size: 11px;
}

.tp-transcript {
  max-height: 24em;
  overflow: auto;
  border: 1px solid rgba(128, 128, 128, 0.25);
  border-radius: 6px;
  padding: 0.4em 0.6em;
  margin-top: 0.4em;
}

.tp-transcript > div {
  padding: 0.15em 0;
  white-space: pre-wrap;
}

.tp-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin: 8px 0;
}

.tp-filters {
  margin-top: 2px;
}

.tp-toggle-group {
  height: 40px;
  align-self: center;
}

.tp-field {
  width: 150px;
  align-self: center;
  --mat-form-field-container-text-size: 14px;
  --mat-select-trigger-text-size: 14px;
  --mat-form-field-outlined-label-text-populated-size: 12px;
  --mat-form-field-subscript-text-size: 11px;
}

:host ::ng-deep .tp-toggle-group .mat-button-toggle {
  height: 38px;
}
:host ::ng-deep .tp-toggle-group .mat-button-toggle-appearance-standard .mat-button-toggle-label-content {
  line-height: 38px;
  padding: 0 12px;
  font-size: 12px;
}
:host ::ng-deep .tp-toggle-group .mat-button-toggle-checked {
  background: rgba(97, 175, 239, 0.18);
  font-weight: 600;
}
:host ::ng-deep .tp-toggle-group mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  vertical-align: -3px;
  margin-right: 4px;
}
:host ::ng-deep .tp-field, :host ::ng-deep .tp-access .tp-field {
  --mat-form-field-container-height: 44px;
  --mat-form-field-filled-with-label-container-padding-top: 18px;
  --mat-form-field-filled-with-label-container-padding-bottom: 6px;
}
:host ::ng-deep .tp-field .mdc-text-field, :host ::ng-deep .tp-field .mat-mdc-text-field-wrapper, :host ::ng-deep .tp-access .tp-field .mdc-text-field, :host ::ng-deep .tp-access .tp-field .mat-mdc-text-field-wrapper {
  border-radius: 6px 6px 0 0 !important;
}
:host ::ng-deep .tp-field input.mat-mdc-input-element, :host ::ng-deep .tp-field textarea.mat-mdc-input-element, :host ::ng-deep .tp-access .tp-field input.mat-mdc-input-element, :host ::ng-deep .tp-access .tp-field textarea.mat-mdc-input-element {
  border: none !important;
  background: transparent !important;
  padding: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}
:host ::ng-deep .tp-field .mat-mdc-form-field-subscript-wrapper, :host ::ng-deep .tp-access .tp-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
:host ::ng-deep .tp-field-block .mat-mdc-text-field-wrapper, :host ::ng-deep .tp-field-block .mat-mdc-form-field-flex {
  height: auto;
}
:host ::ng-deep .tp-field-block .mat-mdc-form-field-subscript-wrapper {
  display: block;
}
:host ::ng-deep .tp-tabbar .mat-button-toggle {
  height: 38px;
}
:host ::ng-deep .tp-tabbar .mat-button-toggle-appearance-standard .mat-button-toggle-label-content {
  line-height: 38px;
  padding: 0 14px;
  font-size: 13px;
}
:host ::ng-deep .tp-tabbar .mat-button-toggle-checked {
  background: rgba(97, 175, 239, 0.18);
  font-weight: 600;
}
:host ::ng-deep .tp-tabbar mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  vertical-align: -3px;
  margin-right: 5px;
}
:host ::ng-deep .tp-accordion .mat-expansion-panel {
  margin-bottom: 8px;
  border-radius: 10px !important;
  box-shadow: none !important;
  border: 1px solid rgba(128, 128, 128, 0.25);
  background: rgba(128, 128, 128, 0.03);
}
:host ::ng-deep .tp-accordion .mat-expansion-panel-header {
  height: 48px !important;
  padding: 0 16px !important;
}
:host ::ng-deep .tp-accordion .mat-expansion-panel-header.mat-expanded {
  height: 52px !important;
}
:host ::ng-deep .tp-accordion .mat-expansion-panel-body {
  padding: 14px 26px 24px !important;
}
:host ::ng-deep .tp-accordion mat-panel-title {
  flex: 0 0 auto;
  min-width: 190px;
  font-weight: 600;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
:host ::ng-deep .tp-accordion mat-panel-title mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  opacity: 0.75;
}
:host ::ng-deep .tp-accordion mat-panel-description {
  font-size: 12px;
  opacity: 0.7;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
:host ::ng-deep .mat-mdc-checkbox .mdc-form-field {
  font-size: 13px;
}
:host ::ng-deep .mat-mdc-slide-toggle .mdc-form-field {
  font-size: 13px;
}
:host ::ng-deep .mat-mdc-menu-item mat-icon {
  margin-right: 8px;
}

.tp-field-date {
  width: 160px;
}

.tp-field-wide {
  width: 260px;
}

.tp-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
  margin: 10px 0 12px;
}

.tp-stat {
  border: 1px solid rgba(128, 128, 128, 0.25);
  border-radius: 10px;
  padding: 10px 14px;
  background: rgba(128, 128, 128, 0.06);
}

.tp-stat-value {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}

.tp-stat-label {
  font-size: 11px;
  opacity: 0.65;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-top: 2px;
}

.tp-table-dense {
  font-variant-numeric: tabular-nums;
}
.tp-table-dense th.num, .tp-table-dense td.num {
  text-align: right;
}
.tp-table-dense td {
  padding: 5px 8px;
}
.tp-table-dense tbody tr:nth-child(even) {
  background: rgba(128, 128, 128, 0.05);
}
.tp-table-dense tbody tr:hover {
  background: rgba(97, 175, 239, 0.08);
}
.tp-table-dense .tp-when {
  white-space: nowrap;
  opacity: 0.8;
}
.tp-table-dense .tp-person {
  font-weight: 600;
}

.tp-chip-model {
  font-size: 11px;
  padding: 1px 8px;
  opacity: 0.85;
}

.tp-source {
  font-size: 11px;
  padding: 1px 8px;
  border-radius: 999px;
  background: rgba(128, 128, 128, 0.15);
  white-space: nowrap;
}
.tp-source[data-source=channel_reply] {
  background: rgba(97, 175, 239, 0.18);
}
.tp-source[data-source=webapp] {
  background: rgba(152, 195, 121, 0.2);
}
.tp-source[data-source=autonomous] {
  background: rgba(128, 128, 128, 0.12);
  opacity: 0.8;
}

.tp-run {
  cursor: pointer;
}

.tp-run-child td {
  opacity: 0.6;
  font-size: 12px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.tp-expand {
  font-size: 16px;
  width: 16px;
  height: 16px;
  vertical-align: -4px;
  opacity: 0.6;
}

.tp-action-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  vertical-align: -3px;
  margin-right: 4px;
  opacity: 0.8;
}
.tp-action-icon[data-action=agent_stopped], .tp-action-icon[data-action=team_stopped], .tp-action-icon[data-action=offboard], .tp-action-icon[data-action=policy_removed] {
  color: #e06c75;
}
.tp-action-icon[data-action=transcript_grant], .tp-action-icon[data-action=transcript_view] {
  color: #e5c07b;
}
.tp-action-icon[data-action=policy_saved], .tp-action-icon[data-action=policy_applied], .tp-action-icon[data-action=offboard_reinstated] {
  color: #61afef;
}

.tp-card {
  border: 1px solid rgba(128, 128, 128, 0.25);
  border-radius: 12px;
  padding: 12px 16px 6px;
  margin: 6px 0 12px;
  background: rgba(128, 128, 128, 0.04);
}

.tp-card-head {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-bottom: 4px;
}
.tp-card-head mat-icon {
  opacity: 0.7;
  margin-top: 1px;
}

.tp-card-title {
  font-weight: 600;
  font-size: 14px;
}

.tp-card-sub {
  font-size: 12px;
  opacity: 0.65;
  margin-top: 1px;
}

.tp-stat-accent {
  border-color: rgba(97, 175, 239, 0.6);
  background: rgba(97, 175, 239, 0.08);
}

.tp-stat-bar {
  margin-top: 8px;
  border-radius: 3px;
}

.tp-share-col {
  width: 120px;
}

.tp-share {
  height: 6px;
  border-radius: 3px;
  background: rgba(128, 128, 128, 0.15);
  overflow: hidden;
}

.tp-share-fill {
  height: 100%;
  background: rgba(97, 175, 239, 0.8);
  border-radius: 3px;
}

.tp-field-narrow {
  width: 110px;
}

.tp-field-grow {
  flex: 1;
  min-width: 240px;
}

.tp-field-block {
  width: 100%;
  display: block;
  margin-top: 6px;
}

.tp-actions-col {
  width: 96px;
  text-align: right;
  white-space: nowrap;
}

.tp-you {
  opacity: 0.55;
  font-weight: 400;
  font-size: 12px;
}

.tp-role {
  font-weight: 600;
  text-transform: capitalize;
}
.tp-role[data-role=owner] {
  color: #e5c07b;
}
.tp-role[data-role=admin] {
  color: #61afef;
}

.tp-health {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
.tp-health mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #98c379;
}
.tp-health.tp-health-bad mat-icon {
  color: #e5c07b;
}

.tp-row-off td {
  opacity: 0.6;
}

.tp-console .tp-agent-grid tbody tr {
  cursor: pointer;
}

.tp-console .tp-agent-grid tbody tr.selected {
  background: rgba(97, 175, 239, 0.14);
}

.tp-card-head mat-slide-toggle {
  margin-right: 8px;
}

.tp-tabbar {
  height: 40px;
}

.tp-tabs .tp-state {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.tp-tabs .tp-state mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.tp-accordion {
  display: block;
  margin-top: 10px;
}

.tp-info {
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.55;
  cursor: help;
  flex: 0 0 auto;
}

.tp-inline-btn {
  font-size: 12px;
  line-height: 28px;
  height: 28px;
  padding: 0 8px;
}

.tp-access .tp-provider {
  border-radius: 10px;
  padding: 8px 12px;
}

.tp-access .tp-provider-head {
  gap: 14px;
}

.tp-access .tp-via {
  gap: 4px;
}

.tp-access .tp-versions {
  display: flex;
  flex-wrap: wrap;
  gap: 0 14px;
}

.tp-access .tp-viewas .tp-field {
  width: 100%;
  margin-bottom: 6px;
}

.tp-access .tp-group-head .tp-field {
  width: 200px;
}

.tp-access .tp-table-dense .tp-field {
  width: 150px;
  margin: 2px 0;
}

.tp-access .tp-table-dense td {
  padding: 3px 6px;
  vertical-align: middle;
}

mat-checkbox {
  font-size: 13px;
}

.tp-toolbar > button[mat-flat-button], .tp-toolbar > button[mat-stroked-button], .tp-toolbar > button[mat-button] {
  height: 38px;
  align-self: center;
}

.tp-tabs {
  align-items: center;
}

.tp-table-dense thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--preset-bg, var(--preset-card, #fff));
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}
.tp-table-dense thead th:hover {
  opacity: 1;
}
.tp-table-dense thead th.tp-sorted {
  opacity: 1;
  color: #61afef;
}

.tp-sort {
  font-size: 14px;
  width: 14px;
  height: 14px;
  vertical-align: -2px;
  margin-left: 2px;
}

.tp-access .tp-table-dense thead th {
  position: static;
  cursor: default;
}

.tp-inline-link {
  color: #61afef;
  cursor: pointer;
  text-decoration: underline;
}

.tp-mcp-row {
  align-items: stretch;
}

.tp-chip-list {
  flex: 1;
  min-width: 320px;
  display: block;
}

:host ::ng-deep .tp-chip-list .mat-mdc-form-field {
  width: 100%;
}
:host ::ng-deep .tp-chip-list .mdc-text-field, :host ::ng-deep .tp-chip-list .mat-mdc-text-field-wrapper {
  border-radius: 6px 6px 0 0 !important;
}
:host ::ng-deep .tp-chip-list .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
:host ::ng-deep .tp-chip-list .mat-mdc-chip {
  font-size: 12px;
  border: 1px solid rgba(97, 175, 239, 0.7) !important;
  background-color: rgba(97, 175, 239, 0.12) !important;
}
:host ::ng-deep .tp-chip-list .mat-mdc-chip .mdc-evolution-chip__action--primary {
  cursor: grab;
}
:host ::ng-deep .tp-chip-list .mat-mdc-chip-remove {
  opacity: 0.7;
}

.tp-mcp-status {
  margin: -2px 0 8px 2px;
  display: flex;
  flex-wrap: wrap;
  gap: 2px 6px;
}

.tp-status-dot {
  font-size: 14px;
  width: 14px;
  height: 14px;
  vertical-align: -2px;
  margin-right: 3px;
  color: #98c379;
}

.tp-issue .tp-status-dot {
  color: #e5c07b;
}

.tp-key-cell {
  white-space: nowrap;
}

.tp-agent-id {
  font-weight: 400;
  opacity: 0.55;
  font-size: 11px;
  font-family: ui-monospace, monospace;
  margin-left: 6px;
}

.tp-members .tp-src {
  margin-left: 6px;
  opacity: 0.55;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.tp-members .tp-role + .tp-chip {
  margin-left: 6px;
}

.tp-successors {
  flex: 1;
}

.tp-successors .tp-toolbar {
  margin: 2px 0;
}

.tp-arrow {
  opacity: 0.5;
  font-size: 18px;
  width: 18px;
  height: 18px;
  align-self: center;
}

.tp-successors {
  margin-top: 8px;
}

.tp-successors-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 4px 0;
}

.tp-successors-table {
  max-width: 760px;
}
.tp-successors-table td {
  padding: 3px 6px;
  vertical-align: middle;
}
.tp-successors-table thead th {
  position: static;
  cursor: default;
}

.tp-arrow-col {
  width: 28px;
  text-align: center;
}

.tp-empty-row td {
  padding: 10px 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/team-policy-widget/team-policy-widget.component.scss"],"names":[],"mappings":"AAAA;EAAe,kBAAA;EAAoB,cAAA;EAAgB,eAAA;AAInD;;AAHA;EAAyB,aAAA;AAOzB;;AANA;EAAY,WAAA;EAAa,aAAA;AAWzB;;AAVA;EAAa,WAAA;EAAa,aAAA;AAe1B;;AAdA;EAAW,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,iDAAA;EAA+C,mBAAA;EAAqB,mBAAA;AAuB7H;AAtBE;EAAS,uBAAA;EAAyB,6BAAA;EAA+B,cAAA;EAAgB,iBAAA;EAAmB,kBAAA;EAAoB,eAAA;AA8B1H;AA7BE;EAAgB,sCAAA;EAAoC,qCAAA;EAAmC,gBAAA;AAkCzF;AAjCE;EAAY,YAAA;EAAa,eAAA;EAAiB,iBAAA;AAsC5C;;AApCA;EAAa,OAAA;AAwCb;;AAvCA;EAAc,8BAAA;EAAgC,sBAAA;EAAwB,oCAAA;AA6CtE;;AA5CA;EAAwB,YAAA;AAgDxB;;AA/CA;EAAgB,uBAAA;EAAyB,0CAAA;EAAwC,cAAA;EAAgB,iBAAA;EAAmB,kBAAA;EAAoB,eAAA;EAAiB,kBAAA;AAyDzJ;;AAxDA;EAAW,gBAAA;EAAkB,YAAA;EAAc,cAAA;EAAgB,YAAA;EAAa,eAAA;EAAiB,0BAAA;EAA4B,UAAA;EAAY,aAAA;AAmEjI;;AAlEA;EAAY,eAAA;AAsEZ;;AArEA;EAAK,kBAAA;AAyEL;;AAxEA;EAAK,kBAAA;EAAoB,eAAA;EAAiB,yBAAA;EAA2B,sBAAA;EAAuB,aAAA;EAAc,aAAA;EAAe,qBAAA;EAAuB,SAAA;EAAW,eAAA;AAoF3J;;AAnFA;EAAc,oBAAA;EAAsB,iBAAA;EAAmB,gBAAA;EAAkB,YAAA;AA0FzE;;AAzFA;EAAS,aAAA;EAAe,sCAAA;EAAwC,aAAA;AA+FhE;;AA9FA;EAA4B,aAAA;AAkG5B;;AAjGA;EAAW,aAAA;EAAe,eAAA;EAAiB,aAAA;AAuG3C;;AAtGA;EAAY,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,mBAAA;AA6GjE;;AA5GA;EAAY,aAAA;EAAe,aAAA;AAiH3B;;AAhHA;EAAU,eAAA;EAAiB,aAAA;EAAc,yBAAA;EAA2B,sBAAA;EAAuB,iBAAA;AAwH3F;;AAvHA;EAAU,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,aAAA;EAAe,eAAA;AA+HxE;;AA9HA;EAAW,OAAA;EAAS,gBAAA;AAmIpB;;AAlIA;EAAY,WAAA;EAAa,yBAAA;EAA2B,aAAA;AAwIpD;AAvIE;EAAS,gBAAA;EAAkB,gBAAA;EAAkB,kDAAA;AA4I/C;AA3IE;EAAK,eAAA;EAAiB,YAAA;EAAa,yBAAA;EAA2B,sBAAA;AAiJhE;;AA/IA;EAAsG,uBAAA;EAAyB,cAAA;EAAgB,2CAAA;EAAyC,kBAAA;EAAoB,gBAAA;EAAkB,aAAA;AAwJ9N;;AAvJA;EAAO,eAAA;EAAiB,aAAA;AA4JxB;;AAzJA;EAAe,aAAA;EAAe,wDAAA;EAA0D,SAAA;EAAW,kBAAA;EAAoB,kBAAA;EAAoB,mCAAA;EAAkC,kBAAA;AAmK7K;;AAlKA;EAAoB,eAAA;EAAiB,iBAAA;AAuKrC;AAtKE;EAAI,eAAA;EAAiB,iDAAA;EAA+C,gBAAA;AA2KtE;AA1KE;EAAU,oCAAA;AA6KZ;;AA3KA;EAAa,+CAAA;EAA6C,kBAAA;EAAoB,eAAA;AAiL9E;AAhLE;EAAQ,aAAA;EAAc,yBAAA;EAA2B,sBAAA;EAAuB,eAAA;EAAiB,aAAA;EAAe,QAAA;EAAU,mBAAA;AAyLpH;AAxLE;EAAS,oBAAA;EAAsB,iBAAA;EAAmB,eAAA;AA6LpD;;AA3LA;EAAc,eAAA;EAAiB,aAAA;EAAe,sBAAA;EAAwB,QAAA;AAkMtE;;AAjMA;EAAkB,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,mBAAA;AAwM5D;;AAvMA;EAAqB,aAAA;EAAc,eAAA;AA4MnC;;AA3MA;EAA4B;IAAe,0BAAA;EAgNzC;EAhNuE;IAAa,iBAAA;IAAmB,eAAA;EAoNvG;AACF;AAlNA;EAAY,oBAAA;EAAsB,eAAA;EAAiB,QAAA;EAAU,mBAAA;AAwN7D;;AAvNA;EAAW,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,gBAAA;EAAkB,oBAAA;EAAsB,2CAAA;EAAyC,uBAAA;EAAyB,cAAA;EAAgB,aAAA;EAAe,eAAA;EAAiB,eAAA;EAAiB,aAAA;EAAc,gBAAA;AAuOzP;AAtOE;EAAQ,YAAA;AAyOV;AAxOE;EAAU,UAAA;AA2OZ;AA1OE;EAAO,UAAA;EAAY,qBAAA;EAAuB,oCAAA;EAAkC,gBAAA;AAgP9E;AA/OE;EAAoB,qBAAA;EAAuB,qCAAA;EAAmC,6BAAA;AAoPhF;AAnPE;EAAmB,eAAA;EAAiB,UAAA;EAAY,qCAAA;AAwPlD;;AApPA;EAAe,2CAAA;EAAyC,kBAAA;EAAoB,iBAAA;EAAmB,aAAA;AA2P/F;AA1PE;EAAQ,aAAA;AA6PV;;AA3PA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;EAAiB,gBAAA;AAmQpF;;AAlQA;EAAoB,uBAAA;EAAyB,aAAA;EAAe,sBAAA;EAAwB,QAAA;AAyQpF;;AAxQA;EAAa,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,gBAAA;EAAkB,eAAA;EAAiB,gBAAA;AAiRrG;;AAhRA;EAAU,oBAAA;EAAsB,SAAA;EAAW,mBAAA;EAAqB,eAAA;EAAiB,YAAA;AAwRjF;;AAvRA;EAAU,oBAAA;EAAsB,2CAAA;EAAyC,kBAAA;EAAoB,gBAAA;AA8R7F;AA7RE;EAAS,uBAAA;EAAyB,YAAA;EAAc,cAAA;EAAgB,aAAA;EAAe,eAAA;EAAiB,iBAAA;EAAmB,eAAA;EAAiB,YAAA;AAuStI;AAtSE;EAAgB,qCAAA;EAAmC,UAAA;EAAY,gBAAA;AA2SjE;;AAzSA;EAAe,aAAA;EAAe,eAAA;EAAiB,aAAA;EAAe,gBAAA;EAAkB,+CAAA;AAiThF;;AA9SA;EAAY,0CAAA;EAAwC,kBAAA;EAAoB,iBAAA;EAAmB,aAAA;AAqT3F;;AApTA;EAAiB,aAAA;EAAe,QAAA;EAAU,mBAAA;EAAqB,kBAAA;AA2T/D;;AA1TA;EAAiB,YAAA;AA8TjB;;AA7TA;EAAoB,OAAA;AAiUpB;;AAhUA;EAAiB,aAAA;EAAe,uBAAA;EAAyB,QAAA;EAAU,aAAA;AAuUnE;AAtUE;EAAU,eAAA;EAAiB,gBAAA;AA0U7B;AAzUE;EAAY,cAAA;EAAgB,YAAA;AA6U9B;AA5UE;EAAW,cAAA;EAAgB,YAAA;AAgV7B;;AA9UA;EAAiB,eAAA;EAAiB,gBAAA;EAAkB,+CAAA;AAoVpD;;AAjVA;EAAY,0CAAA;EAAwC,kBAAA;EAAoB,iBAAA;EAAmB,aAAA;AAwV3F;AAvVE;EAAc,uCAAA;AA0VhB;;AAxVA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;AA+VhE;;AA9VA;EAAiB,gBAAA;AAkWjB;;AAjWA;EAAgB,WAAA;EAAa,eAAA;AAsW7B;;AArWA;EAAY,cAAA;EAAgB,eAAA;EAAiB,mBAAA;AA2W7C;;AA1WA;EAAe,sCAAA;EAAoC,cAAA;AA+WnD;;AA9WA;EAAiB,eAAA;EAAiB,gBAAA;EAAkB,+CAAA;AAoXpD;;AAnXA;EAAW,WAAA;AAuXX;;AAtXA;EAAa,WAAA;EAAa,uBAAA;EAAyB,cAAA;EAAgB,2CAAA;EAAyC,kBAAA;EAAoB,gBAAA;EAAkB,aAAA;EAAe,eAAA;AAiYjK;;AAhYA;EAA0B,eAAA;AAoY1B;AAnYE;EAAU,qCAAA;AAsYZ;AArYE;EAAa,oCAAA;AAwYf;AAvYE;EAAiC,+CAAA;AA0YnC;;AAxYA;EAAkB,cAAA;EAAgB,eAAA;AA6YlC;;AA5YA;EAAa,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,eAAA;EAAiB,eAAA;AAoZnF;AAnZE;EAAQ,aAAA;AAsZV;AArZE;EAAY,WAAA;EAAa,YAAA;EAAc,oBAAA;EAAsB,qCAAA;EAAmC,kBAAA;EAAoB,4BAAA;AA6ZtH;AA5ZE;EAAY,kBAAA;EAAoB,QAAA;EAAU,SAAA;EAAW,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,gBAAA;EAAkB,sBAAA;AAsaxH;AAraE;EAA4B,mBAAA;AAwa9B;AAvaE;EAAsC,UAAA;AA0axC;;AAxaA;EAAU,aAAA;EAAc,eAAA;AA6axB;;AA3aA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,2CAAA;EAAyC,kBAAA;EAAoB,oBAAA;EAAoB,iBAAA;AAobpI;;AAnbA;EAAuB,iBAAA;EAAkB,qBAAA;AAwbzC;;AArbA;EAAc,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;EAAiB,aAAA;AA6b9E;;AA5bA;EAAc,eAAA;AAgcd;;AA/bA;EAAmB,YAAA;EAAc,kBAAA;AAocjC;;AAncA;EAAY,YAAA;EAAc,kBAAA;EAExB,0CAAA;EACA,oCAAA;EACA,yDAAA;EACA,0CAAA;AAucF;;AAncI;EAAqB,YAAA;AAuczB;AAtcI;EAA0E,iBAAA;EAAmB,eAAA;EAAiB,eAAA;AA2clH;AA1cI;EAA6B,oCAAA;EAAkC,gBAAA;AA8cnE;AA7cI;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,oBAAA;EAAsB,iBAAA;AAodjF;AAldE;EAIE,uCAAA;EACA,8DAAA;EACA,gEAAA;AAidJ;AAhdI;EAA+C,qCAAA;AAmdnD;AAldI;EAA8D,uBAAA;EAAyB,kCAAA;EAAoC,qBAAA;EAAuB,2BAAA;EAA6B,2BAAA;AAydnL;AAxdI;EAAwC,aAAA;AA2d5C;AAzdoB;EAAwD,YAAA;AA4d5E;AA5d4F;EAAwC,cAAA;AA+dpI;AA7dI;EAAqB,YAAA;AAgezB;AA/dI;EAA0E,iBAAA;EAAmB,eAAA;EAAiB,eAAA;AAoelH;AAneI;EAA6B,oCAAA;EAAkC,gBAAA;AAuenE;AAteI;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,oBAAA;EAAsB,iBAAA;AA6ejF;AA1eI;EAAuB,kBAAA;EAAoB,8BAAA;EAAgC,2BAAA;EAA6B,2CAAA;EAAyC,qCAAA;AAifrJ;AA/eI;EAA8B,uBAAA;EAAyB,0BAAA;AAmf3D;AAlfI;EAA2C,uBAAA;AAqf/C;AApfI;EAA4B,kCAAA;AAufhC;AAtfI;EAAkB,cAAA;EAAgB,gBAAA;EAAkB,gBAAA;EAAkB,eAAA;EAAiB,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;AA+ftI;AA9fM;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,aAAA;AAogB7D;AAlgBI;EAAwB,eAAA;EAAiB,YAAA;EAAa,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,gBAAA;EAAkB,mBAAA;EAAqB,uBAAA;AA4gBtJ;AA1gBE;EAAoC,eAAA;AA6gBtC;AA5gBE;EAAwC,eAAA;AA+gB1C;AA9gBE;EAA8B,iBAAA;AAihBhC;;AA/gBA;EAAiB,YAAA;AAmhBjB;;AAlhBA;EAAiB,YAAA;AAshBjB;;AArhBA;EAAY,aAAA;EAAe,2DAAA;EAA6D,SAAA;EAAW,mBAAA;AA4hBnG;;AA3hBA;EAAW,2CAAA;EAAyC,mBAAA;EAAqB,kBAAA;EAAoB,qCAAA;AAkiB7F;;AAjiBA;EAAiB,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;EAAwB,gBAAA;EAAkB,kCAAA;AAyiB9F;;AAxiBA;EAAiB,eAAA;EAAiB,aAAA;EAAc,yBAAA;EAA2B,sBAAA;EAAuB,eAAA;AAgjBlG;;AA/iBA;EAAkB,kCAAA;AAmjBlB;AAljBE;EAAiB,iBAAA;AAqjBnB;AApjBE;EAAK,gBAAA;AAujBP;AAtjBE;EAA2B,qCAAA;AAyjB7B;AAxjBE;EAAiB,oCAAA;AA2jBnB;AA1jBE;EAAW,mBAAA;EAAqB,YAAA;AA8jBlC;AA7jBE;EAAa,gBAAA;AAgkBf;;AA9jBA;EAAiB,eAAA;EAAiB,gBAAA;EAAkB,aAAA;AAokBpD;;AAnkBA;EAAa,eAAA;EAAiB,gBAAA;EAAkB,oBAAA;EAAsB,qCAAA;EAAmC,mBAAA;AA2kBzG;AA1kBE;EAAiC,oCAAA;AA6kBnC;AA5kBE;EAA0B,oCAAA;AA+kB5B;AA9kBE;EAA8B,qCAAA;EAAmC,YAAA;AAklBnE;;AAhlBA;EAAU,eAAA;AAolBV;;AAnlBA;EAAmB,YAAA;EAAa,eAAA;EAAiB,gBAAA;EAAkB,mBAAA;AA0lBnE;;AAzlBA;EAAa,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,oBAAA;EAAsB,YAAA;AAimB/E;;AAhmBA;EAAkB,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,oBAAA;EAAsB,iBAAA;EAAmB,YAAA;AAymBvG;AAxmBE;EAA4H,cAAA;AA2mB9H;AA1mBE;EAAsE,cAAA;AA6mBxE;AA5mBE;EAAuG,cAAA;AA+mBzG;;AA5mBA;EAAW,2CAAA;EAAyC,mBAAA;EAAqB,sBAAA;EAAwB,kBAAA;EAAoB,qCAAA;AAonBrH;;AAnnBA;EAAgB,aAAA;EAAe,SAAA;EAAW,uBAAA;EAAyB,kBAAA;AA0nBnE;AAznBE;EAAW,YAAA;EAAa,eAAA;AA6nB1B;;AA3nBA;EAAiB,gBAAA;EAAkB,eAAA;AAgoBnC;;AA/nBA;EAAe,eAAA;EAAiB,aAAA;EAAc,eAAA;AAqoB9C;;AApoBA;EAAkB,qCAAA;EAAmC,oCAAA;AAyoBrD;;AAxoBA;EAAe,eAAA;EAAiB,kBAAA;AA6oBhC;;AA5oBA;EAAgB,YAAA;AAgpBhB;;AA/oBA;EAAY,WAAA;EAAa,kBAAA;EAAoB,qCAAA;EAAmC,gBAAA;AAspBhF;;AArpBA;EAAiB,YAAA;EAAc,mCAAA;EAAiC,kBAAA;AA2pBhE;;AAzpBA;EAAmB,YAAA;AA6pBnB;;AA5pBA;EAAiB,OAAA;EAAS,gBAAA;AAiqB1B;;AAhqBA;EAAkB,WAAA;EAAa,cAAA;EAAgB,eAAA;AAsqB/C;;AArqBA;EAAkB,WAAA;EAAa,iBAAA;EAAmB,mBAAA;AA2qBlD;;AA1qBA;EAAU,aAAA;EAAc,gBAAA;EAAkB,eAAA;AAgrB1C;;AA/qBA;EAAW,gBAAA;EAAkB,0BAAA;AAorB7B;AAnrBE;EAAuB,cAAA;AAsrBzB;AArrBE;EAAuB,cAAA;AAwrBzB;;AAtrBA;EAAa,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,mBAAA;AA6rBlE;AA5rBE;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,cAAA;AAksBzD;AAjsBE;EAA2B,cAAA;AAosB7B;;AAlsBA;EAAiB,YAAA;AAssBjB;;AArsBA;EAAsC,eAAA;AAysBtC;;AAxsBA;EAA+C,oCAAA;AA4sB/C;;AA3sBA;EAAiC,iBAAA;AA+sBjC;;AA5sBA;EAAa,YAAA;AAgtBb;;AA/sBA;EAAqB,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;AAqtBhE;AArtB0E;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;AA0tBnH;;AAztBA;EAAgB,cAAA;EAAgB,gBAAA;AA8tBhC;;AA7tBA;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,aAAA;EAAc,YAAA;EAAc,cAAA;AAsuBnF;;AAruBA;EAAiB,eAAA;EAAiB,iBAAA;EAAmB,YAAA;EAAc,cAAA;AA4uBnE;;AA3uBA;EAA0B,mBAAA;EAAqB,iBAAA;AAgvB/C;;AA/uBA;EAA+B,SAAA;AAmvB/B;;AAlvBA;EAAqB,QAAA;AAsvBrB;;AArvBA;EAA0B,aAAA;EAAe,eAAA;EAAiB,WAAA;AA2vB1D;;AA1vBA;EAAkC,WAAA;EAAa,kBAAA;AA+vB/C;;AA9vBA;EAAsC,YAAA;AAkwBtC;;AAjwBA;EAAuC,YAAA;EAAc,aAAA;AAswBrD;;AArwBA;EAAgC,gBAAA;EAAkB,sBAAA;AA0wBlD;;AAzwBA;EAAe,eAAA;AA6wBf;;AA3wBA;EAAoH,YAAA;EAAc,kBAAA;AAgxBlI;;AA/wBA;EAAW,mBAAA;AAmxBX;;AAhxBA;EAA2B,gBAAA;EAAkB,MAAA;EAAQ,UAAA;EAAY,sDAAA;EAAwD,eAAA;EAAiB,yBAAA;UAAA,iBAAA;EAAmB,mBAAA;AA0xB7J;AAzxBE;EAAU,UAAA;AA4xBZ;AA3xBE;EAAc,UAAA;EAAY,cAAA;AA+xB5B;;AA7xBA;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,oBAAA;EAAsB,gBAAA;AAqyB7E;;AApyBA;EAAsC,gBAAA;EAAkB,eAAA;AAyyBxD;;AAvyBA;EAAkB,cAAA;EAAgB,eAAA;EAAiB,0BAAA;AA6yBnD;;AA3yBA;EAAc,oBAAA;AA+yBd;;AA9yBA;EAAgB,OAAA;EAAS,gBAAA;EAAkB,cAAA;AAozB3C;;AAlzBE;EAAsB,WAAA;AAszBxB;AArzBE;EAA+C,qCAAA;AAwzBjD;AAvzBE;EAAwC,aAAA;AA0zB1C;AAzzBE;EAAgB,eAAA;EAAiB,oDAAA;EAAkD,qDAAA;AA8zBrF;AA7zBE;EAAqD,YAAA;AAg0BvD;AA/zBE;EAAuB,YAAA;AAk0BzB;;AAh0BA;EAAiB,sBAAA;EAAwB,aAAA;EAAe,eAAA;EAAiB,YAAA;AAu0BzE;;AAt0BA;EAAiB,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,oBAAA;EAAsB,iBAAA;EAAmB,cAAA;AA+0BtG;;AA90BA;EAA2B,cAAA;AAk1B3B;;AAh1BA;EAAe,mBAAA;AAo1Bf;;AAl1BA;EAAe,gBAAA;EAAkB,aAAA;EAAc,eAAA;EAAiB,oCAAA;EAAsC,gBAAA;AA01BtG;;AAx1BA;EAAsB,gBAAA;EAAkB,aAAA;EAAc,eAAA;EAAiB,yBAAA;EAA2B,sBAAA;AAg2BlG;;AA/1BA;EAAkC,gBAAA;AAm2BlC;;AAj2BA;EAAiB,OAAA;AAq2BjB;;AAp2BA;EAA6B,aAAA;AAw2B7B;;AAv2BA;EAAY,YAAA;EAAa,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,kBAAA;AA+2BrE;;AA72BA;EAAiB,eAAA;AAi3BjB;;AAh3BA;EAAsB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,aAAA;AAu3BrE;;AAt3BA;EAAuB,gBAAA;AA03BvB;AAz3BE;EAAK,gBAAA;EAAkB,sBAAA;AA63BzB;AA53BE;EAAW,gBAAA;EAAkB,eAAA;AAg4B/B;;AA93BA;EAAgB,WAAA;EAAa,kBAAA;AAm4B7B;;AAl4BA;EAAmB,iBAAA;AAs4BnB","sourcesContent":[".team-policy { padding: 12px 14px; overflow: auto; font-size: 13px; }\n.tp-loading, .tp-muted { opacity: .65; }\n.tp-error { color: #d66; margin: 6px 0; }\n.tp-notice { color: #3a7; margin: 6px 0; }\n.tp-tabs { display: flex; align-items: center; gap: 6px; border-bottom: 1px solid rgba(128,128,128,.3); margin-bottom: 12px; padding-bottom: 6px;\n  button { background: transparent; border: 1px solid transparent; color: inherit; padding: 5px 12px; border-radius: 6px; cursor: pointer; }\n  button.active { border-color: rgba(128,128,128,.5); background: rgba(128,128,128,.12); font-weight: 600; }\n  .tp-state { opacity: .6; font-size: 12px; margin-right: 8px; }\n}\n.tp-spacer { flex: 1; }\n.tp-primary { background: #61afef !important; color: #fff !important; border-color: transparent !important; }\n.tp-primary[disabled] { opacity: .5; }\n.tp-secondary { background: transparent; border: 1px solid rgba(128,128,128,.5); color: inherit; padding: 4px 10px; border-radius: 6px; cursor: pointer; margin: 6px 0 12px; }\n.tp-link { background: none; border: none; color: inherit; opacity: .6; cursor: pointer; text-decoration: underline; padding: 0; font: inherit; }\n.tp-small { font-size: 12px; }\nh3 { margin: 6px 0 10px; }\nh4 { margin: 18px 0 6px; font-size: 12px; text-transform: uppercase; letter-spacing: .04em; opacity: .75; display: flex; align-items: baseline; gap: 10px; flex-wrap: wrap; }\n.tp-h4-note { text-transform: none; letter-spacing: 0; font-weight: 400; opacity: .8; }\n.tp-kv { display: grid; grid-template-columns: max-content 1fr; gap: 4px 14px; }\n.tp-kv div:nth-child(odd) { opacity: .65; }\n.tp-grid { display: flex; flex-wrap: wrap; gap: 4px 16px; }\n.tp-check { display: inline-flex; align-items: center; gap: 6px; white-space: nowrap; }\n.tp-block { display: flex; margin: 8px 0; }\n.tp-sub { font-size: 11px; opacity: .65; text-transform: uppercase; letter-spacing: .04em; margin-right: 8px; }\n.tp-row { display: flex; align-items: center; gap: 10px; margin: 6px 0; flex-wrap: wrap; }\n.tp-wide { flex: 1; min-width: 240px; }\n.tp-table { width: 100%; border-collapse: collapse; margin: 4px 0;\n  th, td { text-align: left; padding: 4px 6px; border-bottom: 1px solid rgba(128,128,128,.25); }\n  th { font-size: 11px; opacity: .7; text-transform: uppercase; letter-spacing: .04em; }\n}\ninput[type=text]:not([matInput]), input:not([type]):not([matInput]), select:not([matNativeControl]) { background: transparent; color: inherit; border: 1px solid rgba(128,128,128,.45); border-radius: 5px; padding: 3px 6px; font: inherit; }\ncode { font-size: 12px; opacity: .85; }\n\n// ---- the sentence + view-as ---------------------------------------------------\n.tp-sentence { display: grid; grid-template-columns: minmax(0, 3fr) minmax(220px, 2fr); gap: 16px; padding: 12px 14px; border-radius: 8px; background: rgba(97,175,239,.10); margin-bottom: 6px; }\n.tp-sentence-text { font-size: 15px; line-height: 1.55;\n  b { cursor: pointer; border-bottom: 1px dotted rgba(97,175,239,.9); font-weight: 600; }\n  b:hover { background: rgba(97,175,239,.18); }\n}\n.tp-viewas { border-left: 1px solid rgba(128,128,128,.3); padding-left: 14px; font-size: 12px;\n  label { opacity: .75; text-transform: uppercase; letter-spacing: .04em; font-size: 11px; display: flex; gap: 8px; align-items: center; }\n  select { text-transform: none; letter-spacing: 0; font-size: 12px; }\n}\n.tp-preview { margin-top: 8px; display: flex; flex-direction: column; gap: 4px; }\n.tp-preview-row { display: flex; flex-wrap: wrap; gap: 4px; align-items: center; }\n.tp-preview-vendor { opacity: .65; min-width: 58px; }\n@media (max-width: 720px) { .tp-sentence { grid-template-columns: 1fr; } .tp-viewas { border-left: none; padding-left: 0; } }\n\n// ---- chips -----------------------------------------------------------------------\n.tp-chips { display: inline-flex; flex-wrap: wrap; gap: 5px; align-items: center; }\n.tp-chip { display: inline-flex; align-items: center; gap: 4px; padding: 2px 9px; border-radius: 999px; border: 1px solid rgba(128,128,128,.45); background: transparent; color: inherit; font: inherit; font-size: 12px; cursor: pointer; opacity: .75; line-height: 1.5;\n  small { opacity: .7; }\n  &:hover { opacity: 1; }\n  &.on { opacity: 1; border-color: #61afef; background: rgba(97,175,239,.18); font-weight: 600; }\n  &.tp-chip-deny.on { border-color: #e06c75; background: rgba(224,108,117,.18); text-decoration: line-through; }\n  &.tp-chip-static { cursor: default; opacity: 1; border-color: rgba(97,175,239,.5); }\n}\n\n// ---- providers -----------------------------------------------------------------\n.tp-provider { border: 1px solid rgba(128,128,128,.25); border-radius: 8px; padding: 6px 10px; margin: 4px 0;\n  &.off { opacity: .55; }\n}\n.tp-provider-head { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; min-height: 26px; }\n.tp-provider-body { padding: 6px 0 2px 26px; display: flex; flex-direction: column; gap: 6px; }\n.tp-switch { display: inline-flex; align-items: center; gap: 8px; font-weight: 600; cursor: pointer; min-width: 190px; }\n.tp-via { display: inline-flex; gap: 10px; align-items: center; font-size: 12px; opacity: .8; }\n.tp-seg { display: inline-flex; border: 1px solid rgba(128,128,128,.45); border-radius: 6px; overflow: hidden;\n  button { background: transparent; border: none; color: inherit; font: inherit; font-size: 12px; padding: 2px 10px; cursor: pointer; opacity: .7; }\n  button.active { background: rgba(128,128,128,.18); opacity: 1; font-weight: 600; }\n}\n.tp-versions { display: flex; flex-wrap: wrap; gap: 2px 14px; padding: 4px 8px; border-left: 2px solid rgba(128,128,128,.3); }\n\n// ---- groups --------------------------------------------------------------------\n.tp-group { border: 1px solid rgba(128,128,128,.3); border-radius: 8px; padding: 8px 10px; margin: 8px 0; }\n.tp-group-head { display: flex; gap: 8px; align-items: center; margin-bottom: 8px; }\n.tp-group-name { width: 200px; }\n.tp-group-members { flex: 1; }\n.tp-group-line { display: flex; align-items: flex-start; gap: 6px; margin: 4px 0;\n  .tp-sub { min-width: 56px; padding-top: 4px; }\n  .tp-allow { color: #61afef; opacity: .9; }\n  .tp-deny { color: #e06c75; opacity: .9; }\n}\n.tp-group-more { margin-top: 6px; padding-top: 6px; border-top: 1px dashed rgba(128,128,128,.3); }\n\n// ---- support console (Agents tab) ------------------------------------------------\n.tp-agent { border: 1px solid rgba(128,128,128,.3); border-radius: 8px; padding: 8px 10px; margin: 8px 0;\n  &.unhealthy { border-color: rgba(224,108,117,.55); }\n}\n.tp-agent-head { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }\n.tp-agent-name { font-weight: 600; }\n.tp-health-ok { color: #3a7; font-size: 12px; }\n.tp-issue { color: #e06c75; font-size: 12px; margin: 3px 0 0 2px; }\n.tp-chip-bad { border-color: rgba(224,108,117,.6); color: #e06c75; }\n.tp-agent-edit { margin-top: 8px; padding-top: 8px; border-top: 1px dashed rgba(128,128,128,.3); }\n.tp-temp { width: 64px; }\n.tp-prompt { width: 100%; background: transparent; color: inherit; border: 1px solid rgba(128,128,128,.45); border-radius: 5px; padding: 6px 8px; font: inherit; font-size: 12px; }\n.tp-agent-grid tbody tr { cursor: pointer;\n  &:hover { background: rgba(128,128,128,.08); }\n  &.selected { background: rgba(97,175,239,.12); }\n  &.row-unhealthy td:first-child { border-left: 2px solid rgba(224,108,117,.7); }\n}\n.tp-issue-count { color: #e06c75; font-size: 12px; }\n.tp-toggle { display: inline-flex; align-items: center; gap: 7px; cursor: pointer; font-size: 12px;\n  input { display: none; }\n  .tp-track { width: 30px; height: 16px; border-radius: 999px; background: rgba(128,128,128,.45); position: relative; transition: background .15s; }\n  .tp-thumb { position: absolute; top: 2px; left: 2px; width: 12px; height: 12px; border-radius: 50%; background: #fff; transition: left .15s; }\n  input:checked + .tp-track { background: #61afef; }\n  input:checked + .tp-track .tp-thumb { left: 16px; }\n}\n.tp-src { opacity: .55; font-size: 11px; }\n\n.tp-transcript { max-height: 24em; overflow: auto; border: 1px solid rgba(128,128,128,.25); border-radius: 6px; padding: .4em .6em; margin-top: .4em; }\n.tp-transcript > div { padding: .15em 0; white-space: pre-wrap; }\n\n// ---- Material-era chrome (UI pass 2026-09-08) --------------------------------------\n.tp-toolbar { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin: 8px 0; }\n.tp-filters { margin-top: 2px; }\n.tp-toggle-group { height: 40px; align-self: center; }\n.tp-field { width: 150px; align-self: center;\n  // one text size for inputs, selects and autocompletes alike\n  --mat-form-field-container-text-size: 14px;\n  --mat-select-trigger-text-size: 14px;\n  --mat-form-field-outlined-label-text-populated-size: 12px;\n  --mat-form-field-subscript-text-size: 11px;\n}\n:host ::ng-deep {\n  .tp-toggle-group {\n    .mat-button-toggle { height: 38px; }\n    .mat-button-toggle-appearance-standard .mat-button-toggle-label-content { line-height: 38px; padding: 0 12px; font-size: 12px; }\n    .mat-button-toggle-checked { background: rgba(97,175,239,.18); font-weight: 600; }\n    mat-icon { font-size: 16px; width: 16px; height: 16px; vertical-align: -3px; margin-right: 4px; }\n  }\n  .tp-field, .tp-access .tp-field {\n    // fill appearance, the app's convention — the theme paints it; we only set the height\n    // through Material's own tokens (label centering follows) and undo the chat composer's\n    // pill radius that .dockview-panel-host leaks onto every text field.\n    --mat-form-field-container-height: 44px;\n    --mat-form-field-filled-with-label-container-padding-top: 18px;\n    --mat-form-field-filled-with-label-container-padding-bottom: 6px;\n    .mdc-text-field, .mat-mdc-text-field-wrapper { border-radius: 6px 6px 0 0 !important; }\n    input.mat-mdc-input-element, textarea.mat-mdc-input-element { border: none !important; background: transparent !important; padding: 0 !important; border-radius: 0 !important; box-shadow: none !important; }\n    .mat-mdc-form-field-subscript-wrapper { display: none; }\n  }\n  .tp-field-block { .mat-mdc-text-field-wrapper, .mat-mdc-form-field-flex { height: auto; } .mat-mdc-form-field-subscript-wrapper { display: block; } }\n  .tp-tabbar {\n    .mat-button-toggle { height: 38px; }\n    .mat-button-toggle-appearance-standard .mat-button-toggle-label-content { line-height: 38px; padding: 0 14px; font-size: 13px; }\n    .mat-button-toggle-checked { background: rgba(97,175,239,.18); font-weight: 600; }\n    mat-icon { font-size: 16px; width: 16px; height: 16px; vertical-align: -3px; margin-right: 5px; }\n  }\n  .tp-accordion {\n    .mat-expansion-panel { margin-bottom: 8px; border-radius: 10px !important; box-shadow: none !important; border: 1px solid rgba(128,128,128,.25); background: rgba(128,128,128,.03); }\n    // !important: styles.scss flattens every expansion panel app-wide (padding: 0 !important)\n    .mat-expansion-panel-header { height: 48px !important; padding: 0 16px !important; }\n    .mat-expansion-panel-header.mat-expanded { height: 52px !important; }\n    .mat-expansion-panel-body { padding: 14px 26px 24px !important; }   // +10px all round (Ben, 09-09): room to breathe\n    mat-panel-title { flex: 0 0 auto; min-width: 190px; font-weight: 600; font-size: 13px; display: inline-flex; align-items: center; gap: 8px;\n      mat-icon { font-size: 18px; width: 18px; height: 18px; opacity: .75; }\n    }\n    mat-panel-description { font-size: 12px; opacity: .7; display: inline-flex; align-items: center; gap: 6px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }\n  }\n  .mat-mdc-checkbox .mdc-form-field { font-size: 13px; }\n  .mat-mdc-slide-toggle .mdc-form-field { font-size: 13px; }\n  .mat-mdc-menu-item mat-icon { margin-right: 8px; }\n}\n.tp-field-date { width: 160px; }\n.tp-field-wide { width: 260px; }\n.tp-stats { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 10px; margin: 10px 0 12px; }\n.tp-stat { border: 1px solid rgba(128,128,128,.25); border-radius: 10px; padding: 10px 14px; background: rgba(128,128,128,.06); }\n.tp-stat-value { font-size: 22px; font-weight: 600; letter-spacing: -.01em; line-height: 1.2; font-variant-numeric: tabular-nums; }\n.tp-stat-label { font-size: 11px; opacity: .65; text-transform: uppercase; letter-spacing: .04em; margin-top: 2px; }\n.tp-table-dense { font-variant-numeric: tabular-nums;\n  th.num, td.num { text-align: right; }\n  td { padding: 5px 8px; }\n  tbody tr:nth-child(even) { background: rgba(128,128,128,.05); }\n  tbody tr:hover { background: rgba(97,175,239,.08); }\n  .tp-when { white-space: nowrap; opacity: .8; }\n  .tp-person { font-weight: 600; }\n}\n.tp-chip-model { font-size: 11px; padding: 1px 8px; opacity: .85; }\n.tp-source { font-size: 11px; padding: 1px 8px; border-radius: 999px; background: rgba(128,128,128,.15); white-space: nowrap;\n  &[data-source=\"channel_reply\"] { background: rgba(97,175,239,.18); }\n  &[data-source=\"webapp\"] { background: rgba(152,195,121,.2); }\n  &[data-source=\"autonomous\"] { background: rgba(128,128,128,.12); opacity: .8; }\n}\n.tp-run { cursor: pointer; }\n.tp-run-child td { opacity: .6; font-size: 12px; padding-top: 2px; padding-bottom: 2px; }\n.tp-expand { font-size: 16px; width: 16px; height: 16px; vertical-align: -4px; opacity: .6; }\n.tp-action-icon { font-size: 16px; width: 16px; height: 16px; vertical-align: -3px; margin-right: 4px; opacity: .8;\n  &[data-action=\"agent_stopped\"], &[data-action=\"team_stopped\"], &[data-action=\"offboard\"], &[data-action=\"policy_removed\"] { color: #e06c75; }\n  &[data-action=\"transcript_grant\"], &[data-action=\"transcript_view\"] { color: #e5c07b; }\n  &[data-action=\"policy_saved\"], &[data-action=\"policy_applied\"], &[data-action=\"offboard_reinstated\"] { color: #61afef; }\n}\n\n.tp-card { border: 1px solid rgba(128,128,128,.25); border-radius: 12px; padding: 12px 16px 6px; margin: 6px 0 12px; background: rgba(128,128,128,.04); }\n.tp-card-head { display: flex; gap: 10px; align-items: flex-start; margin-bottom: 4px;\n  mat-icon { opacity: .7; margin-top: 1px; }\n}\n.tp-card-title { font-weight: 600; font-size: 14px; }\n.tp-card-sub { font-size: 12px; opacity: .65; margin-top: 1px; }\n.tp-stat-accent { border-color: rgba(97,175,239,.6); background: rgba(97,175,239,.08); }\n.tp-stat-bar { margin-top: 8px; border-radius: 3px; }\n.tp-share-col { width: 120px; }\n.tp-share { height: 6px; border-radius: 3px; background: rgba(128,128,128,.15); overflow: hidden; }\n.tp-share-fill { height: 100%; background: rgba(97,175,239,.8); border-radius: 3px; }\n\n.tp-field-narrow { width: 110px; }\n.tp-field-grow { flex: 1; min-width: 240px; }\n.tp-field-block { width: 100%; display: block; margin-top: 6px; }\n.tp-actions-col { width: 96px; text-align: right; white-space: nowrap; }\n.tp-you { opacity: .55; font-weight: 400; font-size: 12px; }\n.tp-role { font-weight: 600; text-transform: capitalize;\n  &[data-role=\"owner\"] { color: #e5c07b; }\n  &[data-role=\"admin\"] { color: #61afef; }\n}\n.tp-health { display: inline-flex; align-items: center; gap: 4px; white-space: nowrap;\n  mat-icon { font-size: 16px; width: 16px; height: 16px; color: #98c379; }\n  &.tp-health-bad mat-icon { color: #e5c07b; }\n}\n.tp-row-off td { opacity: .6; }\n.tp-console .tp-agent-grid tbody tr { cursor: pointer; }\n.tp-console .tp-agent-grid tbody tr.selected { background: rgba(97,175,239,.14); }\n.tp-card-head mat-slide-toggle { margin-right: 8px; }\n\n// ---- Access tab accordion ------------------------------------------------------------\n.tp-tabbar { height: 40px; }\n.tp-tabs .tp-state { display: inline-flex; align-items: center; gap: 4px; mat-icon { font-size: 16px; width: 16px; height: 16px; } }\n.tp-accordion { display: block; margin-top: 10px; }\n.tp-info { font-size: 16px; width: 16px; height: 16px; opacity: .55; cursor: help; flex: 0 0 auto; }\n.tp-inline-btn { font-size: 12px; line-height: 28px; height: 28px; padding: 0 8px; }\n.tp-access .tp-provider { border-radius: 10px; padding: 8px 12px; }\n.tp-access .tp-provider-head { gap: 14px; }\n.tp-access .tp-via { gap: 4px; }\n.tp-access .tp-versions { display: flex; flex-wrap: wrap; gap: 0 14px; }\n.tp-access .tp-viewas .tp-field { width: 100%; margin-bottom: 6px; }\n.tp-access .tp-group-head .tp-field { width: 200px; }\n.tp-access .tp-table-dense .tp-field { width: 150px; margin: 2px 0; }\n.tp-access .tp-table-dense td { padding: 3px 6px; vertical-align: middle; }\nmat-checkbox { font-size: 13px; }\n\n.tp-toolbar > button[mat-flat-button], .tp-toolbar > button[mat-stroked-button], .tp-toolbar > button[mat-button] { height: 38px; align-self: center; }\n.tp-tabs { align-items: center; }\n\n// sticky, sortable headers (the widget body is the scroll container)\n.tp-table-dense thead th { position: sticky; top: 0; z-index: 1; background: var(--preset-bg, var(--preset-card, #fff)); cursor: pointer; user-select: none; white-space: nowrap;\n  &:hover { opacity: 1; }\n  &.tp-sorted { opacity: 1; color: #61afef; }\n}\n.tp-sort { font-size: 14px; width: 14px; height: 14px; vertical-align: -2px; margin-left: 2px; }\n.tp-access .tp-table-dense thead th { position: static; cursor: default; }\n\n.tp-inline-link { color: #61afef; cursor: pointer; text-decoration: underline; }\n\n.tp-mcp-row { align-items: stretch; }\n.tp-chip-list { flex: 1; min-width: 320px; display: block; }\n:host ::ng-deep .tp-chip-list {\n  .mat-mdc-form-field { width: 100%; }\n  .mdc-text-field, .mat-mdc-text-field-wrapper { border-radius: 6px 6px 0 0 !important; }\n  .mat-mdc-form-field-subscript-wrapper { display: none; }\n  .mat-mdc-chip { font-size: 12px; border: 1px solid rgba(97,175,239,.7) !important; background-color: rgba(97,175,239,.12) !important; }\n  .mat-mdc-chip .mdc-evolution-chip__action--primary { cursor: grab; }\n  .mat-mdc-chip-remove { opacity: .7; }\n}\n.tp-mcp-status { margin: -2px 0 8px 2px; display: flex; flex-wrap: wrap; gap: 2px 6px; }\n.tp-status-dot { font-size: 14px; width: 14px; height: 14px; vertical-align: -2px; margin-right: 3px; color: #98c379; }\n.tp-issue .tp-status-dot { color: #e5c07b; }\n\n.tp-key-cell { white-space: nowrap; }\n\n.tp-agent-id { font-weight: 400; opacity: .55; font-size: 11px; font-family: ui-monospace, monospace; margin-left: 6px; }\n\n.tp-members .tp-src { margin-left: 6px; opacity: .55; font-size: 11px; text-transform: uppercase; letter-spacing: .04em; }\n.tp-members .tp-role + .tp-chip { margin-left: 6px; }\n\n.tp-successors { flex: 1; }\n.tp-successors .tp-toolbar { margin: 2px 0; }\n.tp-arrow { opacity: .5; font-size: 18px; width: 18px; height: 18px; align-self: center; }\n\n.tp-successors { margin-top: 8px; }\n.tp-successors-head { display: flex; align-items: center; gap: 10px; margin: 4px 0; }\n.tp-successors-table { max-width: 760px;\n  td { padding: 3px 6px; vertical-align: middle; }\n  thead th { position: static; cursor: default; }\n}\n.tp-arrow-col { width: 28px; text-align: center; }\n.tp-empty-row td { padding: 10px 6px; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
